<template>
  <div class="intelligentAgriculture-page">
    <!-- 乡村资源一张图 -->
    <div class="haeder-container blackStatic" style="height:141px;">
        <Header></Header>
        <Nav></Nav>
    </div>
    	<div class="main text-img-box">
			<div class="top-banner" style="position: relative;">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/gaobiaozhun/gbzbg.png">            
            </div>
            <div style="background:#F4F9EF;text-align: center;padding: 60px;height:240px;position: relative;    margin-bottom: 680px;">
                <div class="wuzhen-title">
                    <img style="width:200px;height:auto;margin:auto;" src="../../assets/img/caseDetails/wuzhen/wuzhentitle.png">
                </div>
                <div style="width: 750px;
                    margin: auto;
                    background: #fff;
                    text-align: justify;
                    padding: 40px;
                    line-height: 31px;
                    color: #333;
                    position: absolute;
                    left: 50%;
                    margin-left: -375px;
                    bottom:-80px;">
                    <h4 style="text-indent: 36px;margin-bottom:20px;color:#289959;font-size: 24px;">桐庐旧县高标准农田示范区建设</h4>
                    <p style="text-indent: 36px;">努力将旧县村官路畈1500余亩高标准农田打造为一二三产融合、产加销游一体、全产业链协同发展的现代农田。</p>
                    <img style="width: 800px;right: -64px;height: auto;position: absolute;    margin-top: 32px;" src="../../assets/img/caseDetails/gaobiaozhun/gbz1.png">             
                </div>
                
            </div>
            		
            <div style="background:#F5F5F5;text-align: center;padding: 60px;height:940px;position: relative;">
                <div class="wuzhen-title" style="margin-bottom:20px">
                    <img style="width:200px;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/nav1.png">
                </div>
                <div class="info-title">
                    <span>区位优势</span><p>旧县街道距离高速出口约10公里，距离县城中心约6公里，具备现代都市生活与乡村旅游往来的便利条件。</p>
                    <span>现状概况</span><p>项目申报区块已集中连片流转1100亩，周边水源充足，具有一定的基础设施条件。</p>
                </div>
                <div class="info-body">
                    <img style="width: 700px;height: auto;margin: auto;margin-top: 24px;margin-bottom: 20px;" src="../../assets/img/caseDetails/gaobiaozhun/gbz2.png"> 
                    <a style="font-size: 12px;color: #999;">注：省农业厅农田建设陈副处长、市农业局建设处处长莅临指导</a>
                    <img style="width: 700px;height: auto;margin: auto;margin-top: 24px;margin-bottom: 20px;" src="../../assets/img/caseDetails/gaobiaozhun/gbz3.png"> 
                    <a style="font-size: 12px;color: #999;">注：县委夏书记调研高标农田建设</a>
                </div>
                
            </div>		
            <div class="inside-box" style="padding-top:20px;">
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">项目规划：</span>
                </div>
                <div class="img-box">
                    <img style="width:100%;height:auto;margin:auto;margin-bottom:10px" src="../../assets/img/caseDetails/gaobiaozhun/gbz4.png">
                    <img style="width:100%;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz22.png">
                </div>   
            </div>
            <div class="inside-box" style="padding-top:20px;">
                 <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">基础建设：</span>
                </div>
                <div class="img-box">
                    <div style="width:30%;float:left;margin-right:3%;padding-top:150px">
                        <div>
                            <i style="display: inline-block;
    width: 12px;
    height: 12px;
    background: #18b125;
    float: left;
    position: relative;
    top: 6px;
    margin-right: 8px;"></i><p style="font-size: 14px;text-align: justify;line-height:24px;"><a style="font-weight:700">农田平整工程</a>：完成247亩，31.5万方</p>
                        </div>
                        <div>
                            <i style="display: inline-block;
    width: 12px;
    height: 12px;
    background: #18b125;
    float: left;
    position: relative;
    top: 6px;
    margin-right: 8px;"></i><p style="font-size: 14px;text-align: justify;line-height:24px;"><a style="font-weight:700">沟渠改造工程</a>：修建及新建灌排沟渠12823米</p>
                            <i style="display: inline-block;
    width: 12px;
    height: 12px;
    background: #18b125;
    float: left;
    position: relative;
    top: 6px;
    margin-right: 8px;"></i><p style="font-size: 14px;text-align: justify;line-height:24px;"><a style="font-weight:700">道路改造工程</a>：新建3.0m~5m宽田间道路2392m、新建下田坡道30座、新建板桥2座.</p>
                        </div>
                    </div>  
                    <div style="width:30%;float:left;margin-right:3%">
                        <img style="width:100%;height:445px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz5.png">
                    </div>
                    <div style="width:30%;float:left">
                        <img style="width:100%;height:445px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz6.png">                       
                    </div>
                </div>    
            </div>

            <div class="inside-box" style="padding-top:120px;padding-bottom:40px;">     
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">主要沟渠改造工程断面设计图</span>
                </div>         
                <div class="img-box">
                    <div style="width:47%;float:left;margin-right:6%">
                        <img style="width:100%;height:445px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz7.png">
                    </div>  
                    <div style="width:47%;float:right">
                        <img style="width:100%;height:445px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz8.png">
                    </div>  
                </div>   
            </div>
            <div style="background:#fff;padding-top:20px;padding-bottom:20px;" >
                <div class="inside-box" style="padding-top:20px;">
                    <div class="inside-nav">
                        <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                            <img style="float:right;" src="../../assets/img/index/arrow.png">
                        </div>                       
                        <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">道路改造工程示意图</span>
                    </div>
                    <div class="img-box">
                        <img style="width:100%;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz9.png">
                    </div>   
                </div>
            </div>
            <div style="background:#F5F5F5;padding-top:20px;padding-bottom:20px;" >
                <div class="inside-box" style="padding-top:20px;">
                    <div class="inside-nav">
                        <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                            <img style="float:right;" src="../../assets/img/index/arrow.png">
                        </div>                       
                        <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">数字大田建设</span>
                    </div>
                    <div class="img-box">
                        <img style="width:100%;height:auto;margin:auto;margin-bottom:30px" src="../../assets/img/caseDetails/gaobiaozhun/gbz10.png">
                        <img style="width:100%;height:auto;margin:auto;margin-bottom:30px" src="../../assets/img/caseDetails/gaobiaozhun/gbz11.png">

                        <div style="width:10%;float:left;margin-right:3%">
                            <span style="width: 20px;display: block;font-size: 24px;margin-top: 60px;margin-left: 64px;line-height: 36px;color: #3fbe76;">指 挥 中 心 建 设</span>
                        </div>  
                        <div style="width:42%;float:left;margin-right:3%">
                            <img style="width:100%;height:315px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz12.png">
                        </div>
                        <div style="width:42%;float:left">
                            <img style="width:100%;height:315px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz13.png">
                        </div>
                        <a style="width: 100%;margin: 20px 0px;display: block;padding-top: 20px;clear: both;">数字大田-浙大联合打造试验田建设</a>
                        <img style="width:100%;height:auto;margin:auto;margin-bottom:30px" src="../../assets/img/caseDetails/gaobiaozhun/gbz14.png">
                    </div>   
                </div>
            </div>
            <div style="background:#fff;padding-top:20px;padding-bottom:20px;" >
                <div class="inside-box" style="padding-top:20px;">
                    <img style="width:240px;margin:auto;margin-bottom:20px" src="../../assets/img/caseDetails/gaobiaozhun/nav2.png">
                    <div class="img-box">
                        <div style="width:30%;float:left;margin-right:3%">
                            <span style="    width: 280px;
    display: block;
    font-size: 16px;
    margin-top: 62px;
    margin-left: 59px;
    line-height: 28px;
    color: #fff;
    background: #3FBE76;
    padding: 20px;
    text-align: left;
    border-radius: 6px;">利用现有6亩农业设施用地，建设烘干房、粮油加工中心、农机维修服务中心占地3亩;新建农机停放车间占地3亩。</span>
                        </div>  
                        <div style="width:67%;float:left;">
                            <img style="width:100%;height:315px;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/gbz15.png">
                        </div>
                    </div>   
                </div>
            </div>
            <div style="background:#F5F5F5;padding-top:20px;padding-bottom:20px;" >
                <div class="inside-box" style="padding-top:20px;">
                    <img style="width:240px;margin:auto;margin-bottom:20px" src="../../assets/img/caseDetails/gaobiaozhun/nav3.png">
                    <div class="img-box">
                        <div class="info-line">
                            <div class="info-title2">
                                <img style="width:34px;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/nav4.png">
                                <a>产业融合-</a><font>美丽田园“共富号”建设</font>
                            </div>
                            <img style="width:100%;height:185px;margin:auto;margin-bottom:16px" src="../../assets/img/caseDetails/gaobiaozhun/gbz17.png">
                        </div>
                    </div>  
                    <div class="img-box">
                        <div class="info-line">
                            <div class="info-title2">
                                <img style="width:34px;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/nav4.png">
                                <a>产业融合中心-</a><font>-主体培育建设</font>
                            </div>
                            <img style="width:100%;height:185px;margin:auto;margin-bottom:16px" src="../../assets/img/caseDetails/gaobiaozhun/gbz18.png">
                        </div>
                    </div>    
                    <div class="img-box">
                        <div class="info-line">
                            <div class="info-title2">
                                <img style="width:34px;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/nav4.png">
                                <a>产业融合中心-</a><font>农产品营销中心建设</font>
                            </div>
                            <img style="width:100%;height:185px;margin:auto;margin-bottom:16px" src="../../assets/img/caseDetails/gaobiaozhun/gbz19.png">
                        </div>
                    </div>   
                    <div class="img-box">
                        <div class="info-line">
                            <div class="info-title2">
                                <img style="width:34px;height:auto;margin:auto;" src="../../assets/img/caseDetails/gaobiaozhun/nav4.png">
                                <a>产业融合中心-</a><font>农事研学建设</font>
                            </div>
                            <img style="width:100%;height:185px;margin:auto;margin-bottom:16px" src="../../assets/img/caseDetails/gaobiaozhun/gbz20.png">
                        </div>
                    </div>   
                </div>
            </div>
		</div>
        
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
.info-title2{
    margin-bottom: 10px;

}
.info-title2 img{
    float: left;
    position: relative;
    bottom: 3px;
    margin-right: 10px;
}
.info-title2 a{
    float: left;
    font-weight: 700;
    color: #289959;
}
.info-title2 font{
    font-weight: 700;
    color: #333;
    float: left;
}
.inside-box{
    width: 1200px;
    margin: auto;
    margin-bottom: 40px;
}
.img-box{
    width: 100%;
}
.inside-nav{
    margin-bottom: 15px;
}

.inside-info{

}
.haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}
.info-title{
    width: 700px;
    margin: auto;
}
.info-title span{
    float: left;
    width: 72px;
    line-height: 24px;
    text-align: center;
    margin-right: 18px;
    background: #289959;
    color: #fff;
    font-size: 12px;
}
.info-title p{
    float: left;
    width: calc(100% - 150px);
    line-height: 23px;
    text-align: left;
    font-size: 12px;
}

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}








@media all and (max-width: 1400px) and (min-width: 820px) {
	.main-bunner-img2 {
		width: 100%;
		height: 600px !important;
		background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
		background-repeat: no-repeat;
		background-size: contain;
	}
}
.main-bunner-img2 {
	width: 100%;
	height: 800px;
	background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-01 {
	width: 100%;
	height: 700px;
	background: rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
}

.maim-module-01-center {
	width: 1200px;
	margin: 0 auto;
}

.maim-module-01-center-text {
	width: 1200px;
	height: 180px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
}

.maim-module-02 {
	width: 100%;
	height: 700px;
	background: #FCF9FC;
	display: flex;
	align-items: center;
}

.maim-module-02-center {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}

.maim-module-02-center-img {
	width: 670px;
	height: 377px;
}

.maim-module-02-center-text {
	width: 460px;
	height: 377px;
	display: flex;
	flex-direction: column;

}

.text-img-box h2 {
	width: 460px;
	height: 45px;
	text-align: right;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(48, 181, 94, 1);
	line-height: 45px;
	margin-top: 25px;
	margin-bottom: 15px;
}

.segmentation {
	width: 460px;
	height: 5px;
	text-align: right;
	margin-top: 5px;
	margin-bottom: 20px;
}

.text02 {
	width: 460px;
	height: 216px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
  line-height: 36px;
  text-align: left;
}

.maim-module-03 {
	width: 100%;
	height: 700px;
	background: #FFFEFF;
	display: flex;
	align-items: center;
}

.img-model {
	width: 670px;
	height: auto;
}

.bottom {
	width: 100%;
	height: 1114px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/bj.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.bottom-center {
	width: 1040px;
	margin: 0 auto;
}

h3 {
	width: 1040px;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 45px;
	padding-top: 63px;
}

.separation-text {
	margin-top: 25px;
	display: flex;
	justify-content: center;
}

.separation-text-01 {
	width: 127px;
	height: 2px;
	text-align: center;
	background: rgba(51, 51, 51, 1);
	opacity: 0.49770000000000003;
}

.list {
	margin-top: 44px;
  text-align: left;
}

.list-text {
	display: inline-block;
	width: 848px;
	height: 36px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
  margin-left: 20px;
}
.village-resources-box{
    width: 1000px;
    margin: auto;
    padding: 80px 0;
    position: relative;
}
.village-resources-cbox{
    width: 27%;
    float: left;
    height: 360px;
    margin: 3%;
    background: #fff;
    box-shadow: 0 5px 2px #eaeaea;
    padding: 20px;
}
.village-resources-cbox img{
    width: 100px;
    margin: auto;
}
.village-resources-cbox h4{
    line-height: 58px;
	font-size: 18px;
}
.village-resources-cbox p{
    line-height: 40px;
    font-size: 16px;
} 
.left-line{
position: absolute;
    left: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-left: 80px;
    top: 89px;
}

.right-line{
position: absolute;
    right: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-right: 80px;
    top: 89px;
}




</style>